export { Heading, HeadingProps } from './Heading'
